<template>
  <div class="navigator-container">
    <div class="navigator-actions">
      <slot></slot>
    </div>
    <div class="navigator">
      <img @click="left" src="/icons/systems-arrow-left.svg" />
      <img
        @click="right"
        class="right-arrow"
        src="/icons/systems-arrow-right.svg"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    elements_count: {
      type: Number,
      default: 0,
    },
    bias: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      pos: 0,
    };
  },
  methods: {
    getScrollDelta() {
      const target = document.getElementById(this.id);
      if (!target) return 0;

      const total_width = target.scrollWidth - this.bias * 2;

      const scroll_delta = this.elements_count
        ? total_width / this.elements_count
        : total_width;

      return scroll_delta - (this.bias * this.elements_count) / 2;
    },
    right() {
      document.getElementById(this.id).scrollLeft += this.getScrollDelta();
      this.$emit("right");

      if (this.pos < this.elements_count - 1) this.pos++;

      if (this.pos == this.elements_count - 1) {
        document.getElementById(this.id).scrollLeft = document.getElementById(
          this.id
        ).scrollWidth;
      }
    },
    left() {
      document.getElementById(this.id).scrollLeft -= this.getScrollDelta();
      this.$emit("left");
      if (this.pos > 0) this.pos--;

      if (this.pos == 0) {
        document.getElementById(this.id).scrollLeft = 0;
      }
    },
  },
};
</script>

<style scoped>
.navigator {
  display: flex;
}

.right-arrow {
  border-left: 1px solid #464646;
}

.navigator img {
  cursor: pointer;
  height: 3.5555555555555554vh;
  width: auto;
}

.navigator.right {
  justify-content: flex-end;
  padding-right: 5.5vh;
}
.navigator-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>
